import { useRemoteConfig, createFlagsScheme, schema } from '@funtech-int/yango-shared';

const headerItemsScheme = createFlagsScheme({
    header_items: schema.arrayOf(schema.string).optional(),
});

const DEFAULT_HEADER_ITEMS = [] as string[];

export function useHeaderItems(): string[] {
    const remoteConfig = useRemoteConfig(headerItemsScheme);

    return remoteConfig.get('header_items') ?? DEFAULT_HEADER_ITEMS;
}
